const INACTIVITY_DURATION = 40000;

export function useKioskTimeout() {
  // Shared state only — no timers here
  const timeoutMode = useState<'param' | 'inactivity' | null>('kioskTimeout:mode', () => null);
  const paramDeadline = useState('kioskTimeout:paramDeadline', () => 0);
  const inactivityDeadline = useState('kioskTimeout:inactivityDeadline', () => 0);
  const showTimeoutDialog = useState('kioskTimeout:showDialog', () => false);
  const countdownSeconds = useState('kioskTimeout:countdown', () => 5);

  const startParamTimeout = (deadline: number) => {
    timeoutMode.value = 'param';
    paramDeadline.value = deadline;
  };

  const startInactivityTimeout = () => {
    timeoutMode.value = 'inactivity';
    inactivityDeadline.value = Date.now() + INACTIVITY_DURATION;
  };

  const resetInactivityDeadline = () => {
    inactivityDeadline.value = Date.now() + INACTIVITY_DURATION;
  };

  const cancelDialog = () => {
    showTimeoutDialog.value = false;
    if (timeoutMode.value === 'inactivity') {
      resetInactivityDeadline();
    }
  };

  const stop = () => {
    showTimeoutDialog.value = false;
    timeoutMode.value = null;
  };

  return {
    timeoutMode,
    paramDeadline,
    inactivityDeadline,
    showTimeoutDialog,
    countdownSeconds,
    startParamTimeout,
    startInactivityTimeout,
    resetInactivityDeadline,
    cancelDialog,
    stop,
  };
}
